module.exports = __webpack_public_path__ + "static/media/jiminez.8f661df9.png";